import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/_home": [5],
		"/aa-offer": [6],
		"/app-choice": [7],
		"/assessment-purchase": [8],
		"/cancel-subscription": [9,[2]],
		"/cancel-subscription/assessment-center": [10,[2]],
		"/cancel-subscription/cancel-feedback": [11,[2]],
		"/cancel-subscription/confirmation": [12,[2]],
		"/cancel-subscription/pause": [13,[2]],
		"/cancel-subscription/pause/manage": [14,[2]],
		"/cancel-subscription/pause/success": [15,[2]],
		"/cancel-subscription/save-offer": [16,[2]],
		"/cancel-subscription/success": [17,[2]],
		"/claimed-offer": [18],
		"/debug/experiment-assign": [19],
		"/desktop-choice": [20],
		"/download-app": [21],
		"/email-preferences": [22],
		"/expired": [23],
		"/forgot-password": [24],
		"/get-started": [25],
		"/inbound-gateway": [26],
		"/inside-pw": [27],
		"/link-entry": [28],
		"/login-expired-link": [31],
		"/login-same-device-success": [32],
		"/login-secondary-device-success": [33],
		"/login": [29],
		"/login/too-many-attempts": [30],
		"/logout": [34],
		"/magic-link-pending": [35],
		"/parent-section": [36,[3]],
		"/parent-section/assessment-center": [37,[3]],
		"/parent-section/membership": [38,[3]],
		"/parent-section/membership/billing": [39,[3]],
		"/parent-section/membership/payment": [40,[3]],
		"/password-reset-success": [42],
		"/password-reset": [41],
		"/premium": [43],
		"/printables": [44],
		"/prospect-register": [45],
		"/purchase-gift": [46],
		"/qr-entry": [47],
		"/reactivation": [48],
		"/redeem": [49],
		"/reset-link-expired": [50],
		"/starter-pack": [51],
		"/subscription-consume": [54],
		"/subscription": [52],
		"/subscription/offer/[offer_hash]": [53],
		"/support-chatbot": [55],
		"/terminate": [56],
		"/universal/magic-link-redeem": [57],
		"/unsupported-browser": [58],
		"/upgrade": [59]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,

	reroute: (() => {})
};

export { default as root } from '../root.svelte';